/* Jota Find · capa de animacion. Revela al hacer scroll, enciende secuencias, cuenta numeros reales y activa el header vidrio. */
(function(){
  var d=document,h=d.documentElement;
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design=window.Shopify&&window.Shopify.designMode;
  var hasIO='IntersectionObserver' in window;

  /* header vidrio */
  var scrolled=false;
  function onScroll(){var s=window.scrollY>40;if(s!==scrolled){scrolled=s;d.body.classList.toggle('jf-scrolled',s);}}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  if(reduced||design||!hasIO)return;
  h.classList.add('jf-m');

  var SEL=['.jfx__eb','.jfx__h','.jfx__cat','.jfx__p','.jfx__pf','.jfx__pack','.jfx__promo','.jfx__step','.jfx__trust .jfx__w>div','.jfx__ctas','.jfx__lead',
    '.jfl__eyebrow','.jfl h2','.jfl__offer','.jfl__trust>div','.jfl__img','.jfl__pains li','.jfl__card','.jfl__ben','.jfl__cmp-col','.jfl__faq details','.jfl__quote','.jfl__pk-item','.jfl__cmp-pack','.jfl__stat','.jfl__pf-song','.jfl__list li',
    '.product-grid__item','.resource-list__item'];

  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});

  function reveal(root){
    var vh=window.innerHeight;
    root.querySelectorAll(SEL.join(',')).forEach(function(el){
      if(el.classList.contains('jf-rv'))return;
      var r=el.getBoundingClientRect();
      if(r.top<vh&&r.bottom>0)return; /* ya visible: no parpadea */
      var p=el.parentElement,i=p?Array.prototype.indexOf.call(p.children,el):0;
      el.style.setProperty('--jf-d',(Math.min(i,5)*.08)+'s');
      el.classList.add('jf-rv');io.observe(el);
    });
  }

  var fio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;fio.unobserve(e.target);
    var kids=Array.prototype.slice.call(e.target.children);
    kids.forEach(function(k,i){setTimeout(function(){k.classList.add('on');if(i===kids.length-1)setTimeout(function(){e.target.classList.add('jf-done');kids.forEach(function(x){x.classList.remove('on');});},900);},i*420);});
  });},{threshold:.35});

  var cio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;cio.unobserve(e.target);
    var el=e.target,to=parseFloat(el.getAttribute('data-jf-count'))||0,t0=null,dur=1100;
    function step(t){if(!t0)t0=t;var k=Math.min((t-t0)/dur,1);el.textContent=Math.round(to*(1-Math.pow(1-k,3)));if(k<1)requestAnimationFrame(step);}
    el.textContent='0';requestAnimationFrame(step);
  });},{threshold:.5});

  function init(root){
    reveal(root);
    root.querySelectorAll('[data-jf-flow]').forEach(function(el){fio.observe(el);});
    root.querySelectorAll('[data-jf-count]').forEach(function(el){cio.observe(el);});
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init(d);});else init(d);
  d.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
